module.exports = __webpack_public_path__ + "img/tune-up-pic.4c561235.png";